// socket.js
import io from "socket.io-client";
const API_SOCKET = process.env.REACT_APP_API_SOCKET;
const socket = API_SOCKET ? io(API_SOCKET) : undefined;
export default socket;
